import TopRangeNavbarSimple from "../components/TopRangeNavbarSimple";
import TopRangeContacts from "../components/TopRangeContacts";
import TopRangeFooter from "../components/TopRangeFooter";
import ScrollToTop from "../components/ScrollToTop";
import TopRangeSafety from "./work-environment-sections/TopRangeSOUT";


function TopRangeWorkEnvironment() {
  return (
    <>
      <TopRangeNavbarSimple />
      <TopRangeSafety />
      <TopRangeContacts />
      <TopRangeFooter />
      <ScrollToTop />
    </>
  );
}

export default TopRangeWorkEnvironment;